import React, { useEffect, useState } from 'react';
import "../../assets/styles/typeConfirm.css";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import imgConfirmFile from "../../imgs/img-confirm-file.png";
import imgConfirmSms from "../../imgs/img-confirm-sms.png";
import InfoUser from "../../components/Profile/InfoUser.js";
import imgBtnUser from "../../imgs/bt-change-name.png";
import imgBtnUserHover from "../../imgs/bt-change-name-hover.png";
import imgBtnPhone from "../../imgs/bt-change-phone.png";
import imgBtnPhoneHover from "../../imgs/bt-change-phone-hover.png";
import imgBtnMail from "../../imgs/bt-change-mail.png";
import imgBtnMailHover from "../../imgs/bt-change-mail-hover.png";
import imgBtnBank from "../../imgs/bt-change-bank.png";
import imgBtnBankHover from "../../imgs/bt-change-bank-hover.png";
import Collapsible from "react-collapsible";
import imgBottom from "../../imgs/img-bottom-cskh.png";
import imgBtnBirthday from "../../imgs/bt-change-birtday.png";
import imgBtnBirthdayHover from "../../imgs/bt-change-birtday-hover.png";
import { checkLastPhoneNumber } from "../../services/api.service.js";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import RequestHistory from "../../components/Profile/RequestHistory";

import * as yup from 'yup';


function TypeConfirm() {
  const location = useLocation();
  const { userName, data, webSetting, lastBank } = location.state || {};
  const [selected, setSelected] = useState(data?.phone_number ? "phone_number" : "files");
  const navigate = useNavigate();

  const schema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email('Email is invalid').required('Email is required'),
    phoneNumber: yup.string().matches(/^[0-9]+$/, 'Phone number must be digits').required('Phone number is required'),
  });

  const shouldNavigate =(!userName || userName === "undefined");
  useEffect(() => {
    if (shouldNavigate) {
      navigate('/');
    }
  }, [navigate, shouldNavigate]);

  if (!shouldNavigate) {
    const selectTypeConfirm = async () => {
      if (!selected) {
        return Swal.fire({ icon: "error", text: "Vui lòng chọn hình thức xác thực" });
      } else {
        if (selected == "phone_number") {
          try {
            Swal.fire({
              title: '<div class="title-type-confirm-sms">Xác Thực Số Điện Thoại</div>',
              showConfirmButton: false,
              allowOutsideClick: false,
              showCloseButton: true,
              html: `
                <div style="text-align:center;">
                  <span style="font-size:14px;">
                    Vui lòng nhập 4 số cuối của số điện thoại đã liên kết với tài khoản F168 để tiến hành xác thực.
                  </span>

                  <div style="display:flex; justify-content:center; gap:10px; margin:20px 0;">
                    <input class="otp-input" maxlength="1" type="tel" inputmode="numeric" pattern="[0-9]*" />
                    <input class="otp-input" maxlength="1" type="tel" inputmode="numeric" pattern="[0-9]*" />
                    <input class="otp-input" maxlength="1" type="tel" inputmode="numeric" pattern="[0-9]*" />
                    <input class="otp-input" maxlength="1" type="tel" inputmode="numeric" pattern="[0-9]*" />
                  </div>

                  <button class="btn-select-type-confirm" id="confirmBtn">
                    Xác nhận
                  </button>
                </div>
              `,
              didOpen: () => {
                const inputs = document.querySelectorAll(".otp-input");

                inputs.forEach((input, index) => {
                  // Style
                  input.style.width = "50px";
                  input.style.height = "50px";
                  input.style.textAlign = "center";
                  input.style.fontSize = "20px";
                  // input.style.border = "1px solid #ccc";
                  input.style.borderRadius = "8px";

                  // Chỉ cho nhập số
                  input.addEventListener("input", (e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");

                    // Auto next
                    if (e.target.value && index < inputs.length - 1) {
                      inputs[index + 1].focus();
                    }
                  });

                  // Backspace về ô trước
                  input.addEventListener("keydown", (e) => {
                    if (e.key === "Backspace" && !input.value && index > 0) {
                      inputs[index - 1].focus();
                    }
                  });
                });

                // Click confirm
                document.getElementById("confirmBtn").addEventListener("click", async () => {
                  let lastPhoneNumber = "";
                  inputs.forEach((i) => (lastPhoneNumber += i.value));

                  if (lastPhoneNumber.length < 4) {
                    Swal.showValidationMessage("Vui lòng nhập đủ 4 số");
                    return;
                  }
                  let result = await checkLastPhoneNumber(userName, lastPhoneNumber);
                  if (result) {
                    Swal.close();
                    navigate("/profile",{ state: {sendType: selected, ...location.state}, replace: !!lastBank });
                  } else {
                    Swal.showValidationMessage(`Xác minh 4 số cuối: ${lastPhoneNumber} ${result ? "" : "chưa đúng với thông tin tài khoản, kiểm tra lại thông tin trước khi nhập"}`);
                    return;
                  }
                  return;
                });
              },
            });
          } catch (error) {
            console.error("Error fetching code:", error);
          }
        } else {
          navigate("/profile",{ state: {sendType: selected, ...location.state}, replace: !!lastBank });
        }
      }
    };
    const options = [
      {
        id: "phone_number",
        image: imgConfirmSms,
        text: "Xác thực nhanh bằng số điện thoại đã đăng ký (khuyến nghị)",
        disable: data.phone_number ? false : true
      },
      {
        id: "files",
        image: imgConfirmFile,
        text: "Xác thực nâng cao bằng cách cung cấp thông tin tài khoản, hình ảnh hóa đơn giao dịch hoặc video xác nhận từ ngân hàng liên kết",
        disable: false,
      },
    ];

    return (
      <div className="container">
        <motion.div
          className="app"
          initial={{ x: "100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100vw", opacity: 0 }}
        >
          <Header isPageSearch={false} data={ location.state }/>
          <br/>
          <RequestHistory key={userName} account={userName} requests={data?.recent_requests || []} lastBank={lastBank} />
          {/* <div className="description-option">
            <span>Để đảm bảo an toàn cho tài khoản, F168 cần xác nhận bạn là chính chủ trước khi tiến hành hỗ trợ.<br/><br/>
              Vui lòng lựa chọn một trong các phương thức xác thực dưới đây:
            </span>
          </div> */}

          <div style={{ margin:"10px" }}>
            <div style={{ width: "100%", maxWidth: 500 }}>
              {options.map((item) => {
                const isActive = selected === item.id;
                return (
                  <div
                    key={item.id}
                    onClick={() => !item.disable && setSelected(item.id)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: 7,
                      marginBottom: 12,
                      border: isActive ? "2px solid #FC8B00" : "1px solid #ccc",
                      borderRadius: 20,
                      cursor: "pointer",
                      // width: "100%",
                      background: isActive ? "#e3f2fd" : "#fff",
                    }}
                  >
                    <img
                      src={item.image}
                      alt=""
                      style={{ width: 60, height: 60, marginRight: 16 }}
                    />
                    <div style={{ flex: 1 }}>
                      <p style={{ margin: 0 }}>{item.text}</p>
                    </div>
                    <input
                      type="radio"
                      checked={isActive}
                      onChange={() => !item.disable && setSelected(item.id)}
                      disabled="true"
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div className="description-option">
            <span>
              Vui lòng lựa chọn phương thức xác thực để tiếp tục thực hiện yêu cầu!
            </span>
          </div>
          <div style={{ justifyContent: "center", display: "flex" }}>
            <button className="btn-select-type-confirm" onClick={selectTypeConfirm}>Xác thực</button>
          </div>
        </motion.div>
      </div>
    );
  }
}

export default TypeConfirm;
